/*
 * Native Possum — np-links-page.js
 * Behaviour for templates/page.links.liquid (see its header).
 * Loaded deferred (it only reacts to clicks / later events).
 */
  (function() {
    // GA4 grid tile click tracking
    document.addEventListener('click', function(e) {
      var tile = e.target.closest('[data-np-grid-tile]');
      if (!tile) return;
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'select_content', {
        content_type: 'instagram_grid_tile',
        item_id: tile.getAttribute('data-tile-destination'),
        content_position: parseInt(tile.getAttribute('data-tile-position'), 10)
      });
    });
  })();
